// Q.解約手数料は発生しますか？
const CANCELLATION_FEE_LINK =
  'https://intercom.help/plus---samurai/ja/articles/6251120-q-%E8%A7%A3%E7%B4%84%E6%89%8B%E6%95%B0%E6%96%99%E3%81%AF%E7%99%BA%E7%94%9F%E3%81%97%E3%81%BE%E3%81%99%E3%81%8B';

// 特商法
const LEGAL_LINK = 'https://www.sejuku.net/corp/legal';

export { CANCELLATION_FEE_LINK, LEGAL_LINK };
